import { connect, ConnectedProps } from "react-redux";
import { TripCategory } from "@hopper-b2b/types";

import { IStoreState } from "../../../../../../reducers/types";
import { setDepartureDate, setReturnDate } from "../../../../actions/actions";
import {
  getDepartureDate,
  getReturnDate,
  getTripCategory,
} from "../../../../reducer";
import { MobileCalendarPicker } from "./component";

const mapDispatchToProps = {
  setDepartureDate,
  setReturnDate,
};
const mapStateToProps = (state: IStoreState) => {
  const departureDate = getDepartureDate(state);
  const returnDate = getReturnDate(state);
  const tripCategory = getTripCategory(state);

  const readyToSearch =
    (tripCategory === TripCategory.ONE_WAY && departureDate) ||
    (tripCategory === TripCategory.ROUND_TRIP && departureDate && returnDate);

  return {
    readyToSearch,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileCalendarPickerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileCalendarPicker = connector(MobileCalendarPicker);
